/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { piDependencies } from './dependenciesPi.generated.js';
import { createUppercasePi } from '../../factoriesAny.js';
export var PIDependencies = {
  piDependencies,
  createUppercasePi
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesUppercasePi.generated.js
// module id = null
// module chunks = 